import type { SVGProps } from 'react';

interface AppLogoIconProps extends SVGProps<SVGSVGElement> {
    title?: string;
}

export default function AppLogoIcon({
    title = 'OrderPilot',
    className,
    children,
    ...props
}: AppLogoIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 428 428"
            role="img"
            aria-hidden={title ? undefined : true}
            className={className}
            {...props}
        >
            {title ? <title>{title}</title> : null}
            {/* === PASTE YOUR LOGO SVG INNER CONTENT BELOW === */}
            <path
                fill="var(--brand)"
                d="m182.19 245.754-89.94 89.939 38.123 38.123q.137-.215.239-.46l51.963-124.625a2.94 2.94 0 0 0-.385-2.977"
            />
            <path
                fill="var(--brand)"
                d="m4.163 427.286 124.625-51.962a2.97 2.97 0 0 0 1.524-1.415q.032-.047.061-.093l-38.122-38.123-91.145 91.144c.798.659 1.928.92 3.057.449M1.106 426.837l91.145-91.144-38.685-38.684c-.471.298-.83.709-1.064 1.175a3 3 0 0 0-.3.554L.24 423.363c-.56 1.344-.084 2.691.866 3.474"
            />
            <path
                fill="var(--brand-spark)"
                d="m92.25 335.693 89.94-89.939c-.773-1.003-2.157-1.523-3.539-.947L54.026 296.77a3 3 0 0 0-.46.239z"
            />
            <path
                fill="var(--brand)"
                fillRule="evenodd"
                d="M217.361 420c115.979 0 210-94.02 210-210S333.34 0 217.361 0c-115.98 0-210 94.02-210 210s94.02 210 210 210m149-210c0 82.29-66.71 149-149 149s-149-66.71-149-149 66.709-149 149-149 149 66.71 149 149"
                clipRule="evenodd"
            />
            <path
                fill="var(--brand)"
                d="M132.351 194.752a5.1 5.1 0 0 0-2.101 1.597 4.8 4.8 0 0 0-.989 2.391c-.093.847.07 1.668.467 2.356a3.46 3.46 0 0 0 1.761 1.501l60.587 24.343a13.9 13.9 0 0 1 7.773 7.772l24.349 60.581c.291.748.813 1.36 1.5 1.756.687.397 1.506.56 2.351.467a4.8 4.8 0 0 0 2.389-.984 5.07 5.07 0 0 0 1.598-2.095l67.411-162.062c.32-.771.425-1.589.303-2.357a3.6 3.6 0 0 0-.995-1.984 3.58 3.58 0 0 0-1.984-.995 4.36 4.36 0 0 0-2.357.303z"
            />
            {children}
        </svg>
    );
}
